"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themes = void 0;
exports.themes = {
    avatar: {
        shared: 'inline-block rounded-button',
        sizes: {
            default: 'h-8 w-8',
            large: 'h-12 w-12',
        },
    },
    avatarCircle: {
        shared: 'inline-block rounded-full',
        sizes: {
            small: 'h-5 w-5',
            default: 'h-8 w-8',
            large: 'h-6 w-6 sm:h-10 sm:w-10',
            extraLarge: 'h-12 w-12',
        },
    },
    avatarLine: {
        container: 'flex-shrink-0',
        inner: 'flex -space-x-1 flex-wrap',
    },
};
//# sourceMappingURL=themes.js.map